var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h2',[_vm._v("用户协议")]),_c('p',[_vm._v("实人认证服务过程中，需要调用您的手机摄像头，并且根据业务场景的不同，\n    需要读取您的身份证个人信息（包括姓名、身份证号码、照片、证件的有效期、签发机关等信息）或者截取您的脸部图像和认证视频，从而实现人脸比对。\n    如果使用不成功，\n    请确保您已经按照要求正确使用本服务，或者向为您办理业务的机构咨询其他办理渠道。\n    本服务由江苏欧索软件提供技术支持。")])])
}]

export { render, staticRenderFns }